<template>
	<div>
		<header-section icon="" title="Seguro Social">
			<template slot="buttons">
				<el-button
						size="medium"
						type="danger"
						icon="el-icon-arrow-left"
						@click="$router.push('/inicio')">
					Regresar
				</el-button>
			</template>
		</header-section>

		<div style="text-align: center">
			<p>
				Estimado becario por el momento tú afiliación a la seguridad social se encuentra en trámite.
			</p>
		</div>

	</div>
</template>

<script>
	const HeaderSection = _ => import(/* webpackChunkName: "js/split/HeaderSection" */'@/components/partials/HeaderSection');

	export default {

		components: {
			HeaderSection
		}
	}
</script>

<style scoped>

</style>